import { useRef, useState } from "react";
import { ImageProps, Image } from "../image/image";
import styles from "./watch-gags-image.module.css";
import Text from "../text/text";
import FutureWrap from "../future-wrap/future-wrap";
import { useMediaQuery } from "react-responsive";
export interface WatchGagsImageProps extends ImageProps {
  gagsSrc?: string;
  containerAnimation?: gsap.core.Animation;
}
const WatchGagsImage = (props: WatchGagsImageProps) => {
  const ctnRef = useRef<HTMLDivElement>(null);
  const [showGags, setGags] = useState(false);
  const isMobile = useMediaQuery({
    query: "(max-width: 1024px)",
  });
  return (
    <div
      className={`${props.className} ${styles.ctn} ${
        showGags ? styles.active : ""
      }`}
      style={props.style}
      ref={ctnRef}
    >


      {props.gagsSrc ? (
        <Image
          {...props}
          src={props.gagsSrc}
          className={`${props.className} ${styles.image} ${styles.gagsImage}`}
        />
      ) : null}

      <Image
        {...props}
        className={`${props.className} ${styles.image} ${styles.sourceImage}`}
      />
      {props.gagsSrc ? (
        <div
          onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            setGags((pre) => !pre);
          }}
          className={styles.buttonBox}
        >
          <FutureWrap
            className={styles.button}
            wrapClassName={styles.buttonWrap}
            chamfer="0"
            cornerHighlight="0"
            fromToDeps={[props.containerAnimation]}
            admissionEffect={{
              animation: {
                duration: 0.4,
              },
              scrollTrigger: !isMobile
                ? {
                    containerAnimation: props.containerAnimation,
                    start: "left 90%",
                    // markers:true
                  }
                : {
                    start: "top 90%",
                  },
            }}
          >
            <Text figmaStyle="body-1">
              {showGags ? "查看拍摄作品" : "查看拍摄花絮"}
            </Text>
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.9999 16.1004L8.9999 2.90039M2.3999 9.50039L15.5999 9.50039"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="square"
              />
            </svg>
          </FutureWrap>
        </div>
      ) : null}
    </div>
  );
};

export default WatchGagsImage;
